/* Carry the selected storefront language into unprefixed Grit Table content links.
   This covers rich text and dynamically inserted content as well as menus. */
(() => {
  const supported = new Set(['en', 'zh', 'de', 'ja', 'fr', 'es']);
  const locale = document.documentElement.lang.toLowerCase().split('-')[0];
  if (!supported.has(locale)) return;
  function update(anchor) {
    if (!anchor.matches('a[href]')) return;
    let url;
    try { url = new URL(anchor.getAttribute('href'), document.baseURI); } catch { return; }
    if (url.protocol !== 'https:' || url.hostname !== 'grit.zenwutoolworks.com' || url.port || url.username || url.password) return;
    // Explicit locale destinations are already intentional. Do not touch citations,
    // assets or unrelated subdomains, or rewrite prose strings.
    if (url.pathname !== '/' && !/^\/grit-[a-z0-9-]+(?:\.html)?$/i.test(url.pathname)) return;
    if (locale === 'en') url.searchParams.set('lang', 'en');
    else { url.pathname = '/' + locale + url.pathname; url.searchParams.delete('lang'); }
    if (url.href !== anchor.href) anchor.href = url.href;
  }
  function scan(node) {
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    update(node);
    node.querySelectorAll('a[href]').forEach(update);
  }
  document.querySelectorAll('a[href]').forEach(update);
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') update(record.target);
      else record.addedNodes.forEach(scan);
    }
  }).observe(document.documentElement, {subtree: true, childList: true, attributes: true, attributeFilter: ['href']});
})();
